import isEmpty from "validator/lib/isEmpty";
import { firstStepRequiredFields } from "../components/CheckoutFormModel/validation";
import { cartLocalStorageService } from "./CartLocalStorageService";

const cartUUID = cartLocalStorageService.cartUUID;
export class CheckoutStorageService {
  static getActiveStep() {
    return JSON.parse(localStorage.getItem(`CheckoutActiveStep-${cartUUID}`));
  }

  static setActiveStep(value) {
    localStorage.setItem(
      `CheckoutActiveStep-${cartUUID}`,
      JSON.stringify(value)
    );
  }

  static getInitValues() {
    return JSON.parse(
      localStorage.getItem(`initialCheckoutValues-${cartUUID}`)
    );
  }

  static setInitValues(values) {
    localStorage.setItem(
      `initialCheckoutValues-${cartUUID}`,
      JSON.stringify(values)
    );
  }

  static transformNullToString(data) {
    return Object.entries(data).reduce((acc, [key, value]) => {
      return {
        ...acc,
        [key]: value || "",
      };
    }, {});
  }

  static checkIfRequiredFieldsIsFilled(requiredFields, values) {
    return requiredFields.every((requiredFieldName) => {
      return !isEmpty(values[requiredFieldName]);
    });
  }

  static splitName(name) {
    const [firstName, lastName = ""] = name.split(" ");
    return {
      firstName,
      lastName,
    };
  }

  static concatenateName(firstName, lastName) {
    return `${firstName} ${lastName}`;
  }

  static prefillFirstStepData(data) {
    if (!data) return;

    // Had to change this, to check if values are set. Since if User navigates away
    // from the page, before this runs, the DB thinks the frontend knows, but it did
    // not get the reply. So now the backend is always sending the data, so the front end
    // needs to check if data should be updated.
    const initValues = CheckoutStorageService.getInitValues();
    if (initValues === null || !initValues.name) {
      const { name, ...restData } =
        CheckoutStorageService.transformNullToString(data);
      const transformedData = {
        ...restData,
        ...CheckoutStorageService.splitName(name),
      };

      CheckoutStorageService.setInitValues(transformedData);

      const allFilled = CheckoutStorageService.checkIfRequiredFieldsIsFilled(
        firstStepRequiredFields,
        transformedData
      );

      if (allFilled) {
        CheckoutStorageService.setActiveStep(1);
      }
    }
  }
}
